import apiService from '../utils/apiInterceptor';

const notificationSettingsService = {
  getAll: () => apiService.get('/admin/notification-settings'),
  updatePlatform: (data) => apiService.put('/admin/notification-settings', data),
  updateUser: (userId, data) => apiService.put(`/admin/notification-settings/users/${userId}`, data),
};

export default notificationSettingsService;
